import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import Skeleton from "@/common/components/Skeleton";
import useUserPermissions from "@/common/hooks/useUserPermissions";
import useEstablishmentUserExternalTokens from "@/features/establishments/hooks/users/useEstablishmentUserExternalTokens";
import { EstablishmentUserExternalTokensData } from "@/features/establishments/types/users/establishmentUserExternalTokens.type";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import EstablishmentUserTokenItem from "./EstablishmentUserTokenItem";
import CreateEstablishmentUserTokenModal from "./CreateEstablishmentUserTokenModal";

const EstablishmentUserTokens = () => {
  const { id } = useParams();

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();

  const {
    data: establishmentUserExtenalTokens,
    meta: establishmentUserExtenalTokensMeta,
    isPending: establishmentUserExtenalTokensIsPending,
  } = useEstablishmentUserExternalTokens<EstablishmentUserExternalTokensData>({
    filters: {
      establishmentUserId: id,
    },
  });

  const hasPermissionToGetUserExternalTokensFilter = useMemo(() => {
    return isUserPermissionsPending || hasUserPermission("Admin::Establishment::UserExternalTokens::Filter");
  }, [isUserPermissionsPending]);

  if (!hasPermissionToGetUserExternalTokensFilter) {
    return null;
  }

  return (
    <div className="w-full rounded-sm p-4 bg-white-100 flex flex-col gap-4">
      <div className="flex w-full items-center justify-between">
        <p>
          Tokens
        </p>

        <div className="flex items-center gap-2">
          <CreateEstablishmentUserTokenModal establishmentUserId={id} />
        </div>
      </div>

      {establishmentUserExtenalTokensIsPending && new Array(2).fill(null).map((_, i) => (
        <Skeleton key={`token_skeleton_${i}`} height={56} />
      ))}

      {!establishmentUserExtenalTokensIsPending && establishmentUserExtenalTokensMeta.total === 0 && (
        <EmptyDataMessage
          className="h-64 overflow-hidden -mt-8"
          imageHeight={180}
          message="Este usuário não possui nenhum token"
        />
      )}

      {!establishmentUserExtenalTokensIsPending && establishmentUserExtenalTokensMeta.total > 0 && (
        establishmentUserExtenalTokens.map((token, index) => (
          <EstablishmentUserTokenItem
            key={token.id}
            token={token}
            displayIndex={establishmentUserExtenalTokens.length - index}
          />
        ))
      )}
    </div>
  );
}

export default EstablishmentUserTokens;
